import { gql } from "@apollo/client";

export const CLIP_OF_THE_DAY = gql`
  query ClipOfTheDay {
    clipOfTheDayNew {
      title
      thumbnailUrl(style: OVERLAY)
      url(orientation: LANDSCAPE)
      id
      internalId
      shareId
      views
      createdAt
      playerGameIdentifier
      reactions {
        type
        count
      }
      comments(first: 0, excludeDeleted: true) {
        pageInfo {
          totalCount
        }
      }
      user {
        internalId
        avatarUrl
        username
      }
      tags {
        key
        value
      }
    }
  }
`;
